import {
    request,
} from '../request.js'

// 权限列表
export function authList(data) {
    return request({
        url: '/web/back/sys/permission/list',
        method: 'post',
        data
    })
}

// 添加
export function addAuth(data) {
    return request({
        url: '/web/back/sys/permission/insert',
        method: 'post',
        data
    })
}

// 修改
export function editAuth(data) {
    return request({
        url: '/web/back/sys/permission/update',
        method: 'post',
        data
    })
}

// 删除
export function delAuth(data) {
    return request({
        url: '/web/back/sys/permission/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelAuth(data) {
    return request({
        url: '/web/back/sys/permission/batch/delete',
        method: 'delete',
        data
    })
}

// 详情
export function detailAuth(data) {
    return request({
        url: '/web/back/sys/permission/' + data,
        method: 'get',
    })
}